import React from 'react';
import PropTypes from 'prop-types';
import styles from './Heading.scss';

function Heading({ description, showDescription = true }) {
  const descriptionNodes = description.map(line => <div key={line}>{line}</div>);

  return (
    <div className={styles.root}>
      <div className={styles.headingWrapper}>
        <div className={styles.logoContainer}>
          <img
            src="/svgs/racing_post_plus_logo.svg"
            className={styles.logo}
            alt="racing post plus logo"
                    />
        </div>
        {showDescription && <div className={styles.description}>{descriptionNodes}</div>}
      </div>
    </div>
  );
}

Heading.propTypes = {
  description: PropTypes.array.isRequired,
};
Heading.defaultProps = {
  description: ['Subscribe now and get all', ' our data and tips'],
};

export { Heading as default };
